import React from 'react';
import Join from '../Images/Join.png';

export default function JoinUs() {

    return (
        <section className='grid grid-cols-1 lg:grid-cols-2 px-5 pt-[10px] md:pt-[30px] md:px-20'>
            <div className='space-y-6'>
                <div className='text-[8vw] md:text-[7vw] font-bold lg:text-7xl'>
                    Why to Join Us?
                </div>
                <div className='text-[6vw] md:text-[4vw] lg:text-2xl'>
                    Our society is a main factor in shaping your college life and building up your character by learning, gaining experience, having fun as well as creating a second family.
                </div>
                <div className='text-[8vw] md:text-[7vw] font-bold lg:text-7xl'>
                    Who can Join Us?
                </div>
                <div className='text-[6vw] md:text-[4vw] lg:text-2xl'>
                    Any student who is eager to learn and explore new things.
                </div>
                <div className="py-4">
                    <a target="_blank" href="/joinus">
                        <button type="button" className="text-white bg-gradient-to-r from-[#101242] ring-[#ed5955] ring-2 to-[#ed5955] transition-all duration-200 font-medium rounded-lg 
                    text-sm px-5 py-2.5 text-center mr-2 mb-2 hover:scale-125 shadow-lg shadow-[#ed5955]/50">Join Us Now!</button>
                    </a>
                </div>
            </div>
            <div className='ml-auto'>
                <img src={Join} className=" md:p-0 p-8 lg:h-80" alt="Join Us"/>
            </div>
        </section>
    );
}